module.exports = __webpack_public_path__ + "static/media/no-record.3e02658b.png";